// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0819 19.7C19.6133 20.178 19.1014 20.6134 18.5523 21H24.2263V23H12.2263C6.15119 23 1.22632 18.0751 1.22632 12C1.22632 5.92487 6.15118 1 12.2263 1C18.3014 1 23.2263 5.92487 23.2263 12C23.2263 14.9977 22.0259 17.7169 20.0819 19.7ZM12.2263 5C11.1217 5 10.2263 5.89543 10.2263 7C10.2263 8.10457 11.1217 9 12.2263 9C13.3309 9 14.2263 8.10457 14.2263 7C14.2263 5.89543 13.3309 5 12.2263 5ZM17.2263 10C16.1217 10 15.2263 10.8954 15.2263 12C15.2263 13.1046 16.1217 14 17.2263 14C18.3309 14 19.2263 13.1046 19.2263 12C19.2263 10.8954 18.3309 10 17.2263 10ZM5.22632 12C5.22632 13.1046 6.12175 14 7.22632 14C8.33089 14 9.22632 13.1046 9.22632 12C9.22632 10.8954 8.33089 10 7.22632 10C6.12175 10 5.22632 10.8954 5.22632 12ZM12.2263 15C11.1217 15 10.2263 15.8954 10.2263 17C10.2263 18.1046 11.1217 19 12.2263 19C13.3309 19 14.2263 18.1046 14.2263 17C14.2263 15.8954 13.3309 15 12.2263 15Z"}}]};

const FilmFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'film-filled',
    ref,
    icon: element,
  },
));

FilmFilledIcon.displayName = 'FilmFilledIcon';

export default FilmFilledIcon;
